import cn from 'classnames';
import { useIntl } from 'react-intl';
import { Element } from 'react-scroll';

const AziendaMission = () => {
  const intl = useIntl();
  return (
    <div className="snf-lx-components-azienda-mission-misson" style={{ display: 'contents' }}>
      <Element name="mission">
        <div className={cn('div-image', `snf-bg-repeat-no-repeat`)}>
          <div className="container-fluid padding px-5 py-5">
            <div className="row ml-2 mb-2">
              <div className="col-auto snf-font-32 mb-4">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>La nostra missione</strong> inizia con le persone'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <div className="row">
                  <div className="col">
                    <img
                      src="/images/mission-people-icon.png"
                      width="100"
                      height="auto"
                      alt="Icona persone"
                    />
                  </div>
                </div>
                <div className="row mb-2 ml-2">
                  <div className="col snf-font-24">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>Chi siamo</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row ml-2">
                  <div className="col pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'Sistemi Informativi è una società del <strong>gruppo IBM</strong> da sempre impegnata nello sviluppo di <strong>soluzioni informatiche</strong> per la modernizzazione e la digitalizzazione di vari settori di industria quali Pubblica Amministrazione, Banche e Assicurazioni, Telecomunicazioni, Energy&Utilities, Travel&Transportation, Consumer, Healthcare&Pharma. '
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="row">
                  <div className="col">
                    <img
                      src="/images/mission-goal-icon.png"
                      width="100"
                      height="auto"
                      alt="Icona montagna"
                    />
                  </div>
                </div>
                <div className="row mb-2 ml-2">
                  <div className="col snf-font-24 ">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>In cosa crediamo</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row ml-2">
                  <div className="col pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'Ciò che ci definisce come azienda è la centralità che diamo alle <strong>persone</strong>, perché è in loro che crediamo ed è a loro che ci rivolgiamo: oltre alla conoscenza approfondita dei settori di industria, le nostre risorse sono coinvolte in <strong>percorsi di crescita e formazione</strong> costanti, per rispondere con consapevolezza e dedizione alle esigenze della digital transformation dei nostri clienti.  '
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="row">
                  <div className="col">
                    <img
                      src="/images/mission-binoculars-icon.png"
                      width="100"
                      height="auto"
                      alt="Icona binocolo"
                    />
                  </div>
                </div>
                <div className="row mb-2 ml-2">
                  <div className="col snf-font-24">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>Uno sguardo verso il futuro</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row ml-2">
                  <div className="col pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'È proprio in quest’ottica che Sistemi Informativi ha avviato, negli ultimi anni, un profondo <strong>processo di trasformazione</strong>, a partire dalla creazione di un <strong>Centro di Innovazione</strong> e attraverso investimenti mirati in aree strategiche come il <strong>Cloud, l’Intelligenza Artificiale</strong> e la <strong>Cyber Security</strong>.'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </div>
  );
};

AziendaMission.displayName = "L'Azienda Storia ";
export { AziendaMission };
